'use strict';

var React = require('react');

var SvgCashRupeeIcon = function SvgCashRupeeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.889 13.893a.75.75 0 0 0-.246-1.032l-1.713-1.054a2.487 2.487 0 0 0 1.059-1.807h1.261a.75.75 0 0 0 0-1.5h-1.25v-.75h1.25a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 1 0 0 1.5h1.75v.75h-1.75a.75.75 0 0 0 0 1.5h1.721a.989.989 0 0 1-.96.75c-.902 0-1.237 1.184-.468 1.657l2.814 1.732a.75.75 0 0 0 1.032-.246Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-5.5 7a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z"
  }));
};
SvgCashRupeeIcon.displayName = "CashRupeeIcon";

exports.SvgCashRupeeIcon = SvgCashRupeeIcon;
